import { type ClassValue, clsx } from "clsx";
import i18n from "i18next";
import { twMerge } from "tailwind-merge";
import { formatDateTime, formatFixed, formatMoney, formatDate as i18nFormatDate } from "./i18n";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatCurrency(amount: number, currency = "CZK"): string {
  return formatMoney(amount, currency);
}

export function formatHours(hours: number): string {
  return `${formatFixed(hours, 2)} h`;
}

export function formatDate(
  date: Date | string,
  timeZone?: string,
  opts?: { withTime?: boolean },
): string {
  return opts?.withTime
    ? formatDateTime(date, undefined, timeZone)
    : i18nFormatDate(date, undefined, timeZone);
}

export function formatRelative(date: Date | string, timeZone?: string): string {
  const d = new Date(date);
  const now = new Date();
  const diffMs = now.getTime() - d.getTime();
  const diffSec = Math.floor(diffMs / 1000);
  const diffMin = Math.floor(diffSec / 60);
  const diffHour = Math.floor(diffMin / 60);
  const diffDay = Math.floor(diffHour / 24);

  if (diffSec < 60) return i18n.t("relativeTime.justNow");
  if (diffMin < 60) return i18n.t("relativeTime.minutesAgo", { count: diffMin });
  if (diffHour < 24) return i18n.t("relativeTime.hoursAgo", { count: diffHour });
  if (diffDay === 1) return i18n.t("relativeTime.yesterday");
  if (diffDay < 7) return i18n.t("relativeTime.daysAgo", { count: diffDay });

  return i18nFormatDate(d, undefined, timeZone);
}
